import makeStyles from '@mui/styles/makeStyles';

const useMacIdAddStyles = makeStyles({
  root: {}
});

export default useMacIdAddStyles;
